import { OktaAuth } from '@okta/okta-auth-js';
import logo from './logo.png';
import i18n from '@app/i18n';
import { getCreationSource } from '@app/helpers/creation-source';

const CALLBACK_PATH = '/login/callback';

// Web Okta Auth Client (used for @okta/okta-react Security component and web auth)
const oktaAuthClient = new OktaAuth({
  clientId: process.env.OKTA_CLIENT_ID || '0oaqwvmw9dLBue3iT0h7',
  issuer:
    process.env.OKTA_ISSUER ||
    'https://himarley-prod.oktapreview.com/oauth2/ausqt450vmoOdOEbT0h7',
  redirectUri: window.location.origin + CALLBACK_PATH,
  scopes: ['openid', 'profile', 'email'],
  pkce: true,
  postLogoutRedirectUri: process.env.APP_HOST || 'http://localhost:8083',
  tokenManager: {
    autoRenew: true, // https://github.com/okta/okta-auth-js/blob/master/docs/autoRenew-notice.md
  },
  services: {
    autoRenew: false,
    autoRemove: false,
  },
  state: getCreationSource(),
});

// Okta classic does not bundle 'fr-CA', so fr-CA users reuse Okta's bundled French strings.
const mapAppLocaleToOktaLocale = (appLocale) => {
  switch (appLocale) {
    case 'fr-CA':
      return 'fr';
    case 'en':
    default:
      return 'en';
  }
};

const buildOverrides = (appLocale) => {
  const t = i18n.getFixedT(appLocale, 'login');
  return {
    'primaryauth.title': t('widget.signInTitle'),
    'primaryauth.submit': t('widget.submit'),
    'oform.next': t('widget.next'),
    'primaryauth.username.placeholder': t('widget.emailPlaceholder'),
    'primaryauth.password.placeholder': t('widget.passwordPlaceholder'),
  };
};

const getOktaSignInConfig = (appLocale) => {
  const oktaLocale = mapAppLocaleToOktaLocale(appLocale);
  const clientId = process.env.OKTA_CLIENT_ID || '0oaqwvmw9dLBue3iT0h7';
  // App embed-link path identifier, sourced per environment (no hardcoded fallback).
  // Combined with clientId it forms the app embed path `/home/oidc_client/<appId>/<labelId>`
  // used as the IdP Discovery requestContext (below).
  const appLabelId = process.env.OKTA_APP_LABEL_ID;
  return {
    baseUrl: 'https://himarley-prod.oktapreview.com',
    clientId,
    redirectUri: `${window.location.origin}/login/callback`,
    authParams: {
      // If your app is configured to use the Implicit flow
      // instead of the Authorization Code with Proof of Code Key Exchange (PKCE)
      // you will need to uncomment the below line
      pkce: true,
      issuer:
        process.env.OKTA_ISSUER ||
        'https://himarley-prod.oktapreview.com/oauth2/ausqt450vmoOdOEbT0h7',
      scopes: ['openid', 'profile', 'email', 'offline_access'],
    },
    features: {
      idpDiscovery: true,
    },
    idpDiscovery: {
      // App embed path lets Okta resolve the application during the WebFinger IdP
      // Discovery call so application-based routing rules can match. Requires
      // IdP-initiated login enabled on the app. See docs/idp-discovery-app-based-routing.md
      requestContext: `/home/oidc_client/${clientId}/${appLabelId}`,
    },
    logo,
    colors: {
      brand: '#F9685D',
    },
    language: oktaLocale,
    i18n: {
      [oktaLocale]: buildOverrides(appLocale),
    },
    useInteractionCodeFlow: false,
    useClassicEngine: true,
    state: getCreationSource(),
  };
};

export {
  getOktaSignInConfig,
  mapAppLocaleToOktaLocale,
  CALLBACK_PATH,
  oktaAuthClient,
};
